module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-dashboard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.AWS_ASSETS + 'logo.png'
    }
  })]), _vm._v(" "), _vm._l((_vm.summary), function(obj, key) {
    return _c('el-col', {
      key: key,
      staticStyle: {
        "padding": "8px"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-card', {
      attrs: {
        "align": "center",
        "body-style": {
          backgroundColor: 'rgb(89, 180, 170)',
          color: '#fff',
          'font-weight': 'bold'
        }
      }
    }, [_c('div', [_vm._v("\n                      " + _vm._s(_vm.$t('TOTAL') + ' ' + _vm.$t(key)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "padding": "0"
      },
      style: ({
        color: key === 'CENTERS' ? '#ACB225' : _vm.links[key].color
      }),
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h1', [_vm._v(_vm._s(obj) + " "), _c('br')])])])], 1)
  })], 2), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.schools), function(center, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 8
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.clickEvent(key)
        }
      }
    }, [_c('el-card', {
      attrs: {
        "align": "center",
        "body-style": {
          padding: '5px 20px'
        }
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, _vm._l((center), function(obj, index) {
      return (index != 'SCHOOL') ? _c('el-col', {
        key: index,
        attrs: {
          "span": 8
        }
      }, [_c('el-button', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickEvent(key, index)
          }
        }
      }, [_c('el-card', {
        attrs: {
          "align": "center",
          "body-style": {
            'font-weight': 'bold',
            padding: '10px 30px'
          }
        }
      }, [_c('div', {
        staticClass: "clearfix",
        style: ({
          color: _vm.links[index].color
        }),
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [_c('h1', [_vm._v(_vm._s(obj))])]), _vm._v(" "), _c('div', [_vm._v("\n                              " + _vm._s(_vm.$t(index)) + "\n                        ")])])], 1)], 1) : _vm._e()
    })), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h2', [_vm._v(_vm._s(_vm.center_name(center)))])])], 1)], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68cb6dc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MasterDashboard.vue
// module id = 610
// module chunks = 1